import React from 'react';
import AppBar from '../../../commons/AppBar'
import ButtonsModules from '../../../commons/ButtonsModules';
import SiteMap  from '../../../commons/SiteMap';
import SpecificComponent from '../../../commons/SpecificComponent';
import { Grid, Switch, Table, TableHead, TableRow, TableCell, TableBody } from '@material-ui/core';
import { TopButtons } from '../../../commons/TopButtons';
import FromServer from '../FromServer';
import BilantChartData from '../Components/BilantChartData';
import PreviziuniChartData from '../Components/PreviziuniChartData';
import { Bar,Chart, HorizontalBar } from 'react-chartjs-2';
import ChartDataLabels from 'chartjs-plugin-datalabels';
import Utils from '../../../providers/Utils';

export default class AnalizaAngajatilor extends SpecificComponent {
    constructor(props) {
      super(props);
       this.state = {
       chartData2:null,
       listRaport:[],
       listFull:[],
       isLunar:false,

        
        mapButtons:[{id:'financiarcontabil', label:'Inapoi Financiar', color:'#900DCB'},
        {id:'arp', label:'Analiza si raportare proiecte(ARP)', color:'#900DCB'}
    ]
}
    }

     componentDidMount(){
      
         this.getBilantData()
         Chart.plugins.unregister(ChartDataLabels);
    }

    goBack = (id) =>{
        this.props.history.push(`/${id}`)
    }

    lunarSapt = (ev) => {

        let fs = new FromServer()

        let cloneList = [...this.state.listFull]

        let date;

        if (this.state.isLunar) {
            date = new Date().setMonth(new Date().getMonth() - 1)




        } else {
            date = new Date().setDate(new Date().getDate() - 7)
        }
        // console.log('date :', new Date(date));

        cloneList = cloneList.filter(c => new Date(c.dataora_propusa) > new Date(date))



        let userIds = cloneList.map(l => l.id_utilizator_responsabil)


        let userRez = []

        let users = [...new Set(userIds)]




        // console.log('users :', users);


        let counter = users.length


        for (let i = 0; i < counter; i++) {
            userRez.push(fs.userAnalize1(users[i], cloneList))
        }


        let counter3 = userRez.length

        let chartData2 =
            {
                chartData: [],

                labels: [this.dictionary.financiarContabil.totalOreCumulateTaskuri,
                this.dictionary.financiarContabil.totalOreDepasiteCompletare,
                this.dictionary.financiarContabil.totalOreAvansCompletare,
                this.dictionary.financiarContabil.procentajDepasire,
                this.dictionary.financiarContabil.procentajAvans
                ]

            }
        for (let i = 0; i < counter3; i++) {


            // chartData2.push([
            //     userRez[i].numeUser,
            //     userRez[i].totalOreCumulateTaskuri,
            //     userRez[i].totalOreDiferentaCompletare > 0 ? Math.abs(userRez[i].totalOreDiferentaCompletare) : 0,
            //     userRez[i].totalOreDiferentaCompletare < 0 ? Math.abs(userRez[i].totalOreDiferentaCompletare) : 0,
            //     userRez[i].pctDepasire > 0 ? Math.abs(userRez[i].pctDepasire) : 0,
            //     userRez[i].pctDepasire < 0 ? Math.abs(userRez[i].pctDepasire) : 0,
            // ])
            chartData2.chartData.push({

                user: userRez[i].numeUser, chartData: [

                    { label: this.dictionary.financiarContabil.totalOreCumulateTaskuri, value: userRez[i].totalOreCumulateTaskuri },
                    { label: this.dictionary.financiarContabil.totalOreDepasiteCompletare, value: userRez[i].totalOreDiferentaCompletare > 0 ? Math.abs(userRez[i].totalOreDiferentaCompletare) : 0 },
                    { label: this.dictionary.financiarContabil.totalOreAvansCompletare, value: userRez[i].totalOreDiferentaCompletare < 0 ? Math.abs(userRez[i].totalOreDiferentaCompletare) : 0 },
                    { label: this.dictionary.financiarContabil.procentajDepasire, value: userRez[i].pctDepasire > 0 ? Math.abs(userRez[i].pctDepasire) : 0 },
                    { label: this.dictionary.financiarContabil.procentajAvans, value: userRez[i].pctDepasire < 0 ? Math.abs(userRez[i].pctDepasire) : 0 }
                ]

            })
        }
        this.setState({
            isLunar: ev.target.checked,
            listRaport: userRez
        })
    }

    getBilantData = async()=>{
        let fs = new FromServer();

        let getData = await fs.getEvaluare()

        // console.log('chartData2 :', chartData2);

        // console.log('chartData2 :', chartData2);

   
        // console.warn('listCapitole :', getData);

       if(getData.r){
        
        this.setState({
            listFull:getData.c.listFull,
            listRaport: getData.c.listRaport,
            chartData2: getData.c.chartData2
      
        })
       }
    }
     render() { 
       return (
          <div>
                <AppBar history={this.props.history} title={this.dictionary.appBar.drawer.financiar} />
             
                <ButtonsModules history={this.props.history}
                    scop={'Financiar'} />

        <div style={{textAlign:'left'}}>
            {this.state.mapButtons.map((b,idx)=>{
                return(
                    <SiteMap 
                        key={idx}
                        b={b}
                        buttonSelected={this.goBack} />
                        
                )
            })}
        </div>
        <h1 className='pm-title'>Analiza utilizatori</h1>
            <div className='container'>
            <div style={{ border: '1px dashed gray' }}>
                            <span>Lunar</span>
                            <Switch
                                className="pm-switch"
                                checked={this.state.isLunar}
                                onChange={(ev) => { this.lunarSapt(ev) }}
                                value='companie'
                            /><span>Saptamanal</span>

                            <Table className='pm-indicatori-table'>
                                <TableHead>
                                    <TableRow>
                                        <TableCell>
                                            {this.dictionary.proiecte.etapeProiect.numeEtapa}
                                        </TableCell>

                                        <TableCell>
                                            {this.dictionary.proiecte.rapoarteProiect.totalOreCumulateTaskuri}
                                        </TableCell>

                                        <TableCell>
                                            {this.dictionary.proiecte.rapoarteProiect.totalOreDiferentaCompletare}
                                        </TableCell>
                                        <TableCell>
                                            {this.dictionary.proiecte.rapoarteProiect.totalOreAvansCompletare}
                                        </TableCell>
                                        <TableCell>
                                            {this.dictionary.proiecte.rapoarteProiect.pctDepasire}
                                        </TableCell>
                                        <TableCell>
                                            {this.dictionary.proiecte.rapoarteProiect.pctAvans}
                                        </TableCell>
                                        <TableCell>
                                            Expl
            </TableCell>
                                    </TableRow>
                                </TableHead>
                                <TableBody>

                                    {this.state.listRaport.map((e, idx) => {
                                        return (
                                            <TableRow key={idx}>
                                                <TableCell style={{ whiteSpace: 'nowrap' }}>
                                                    {e.numeUser}
                                                </TableCell>

                                                <TableCell style={{ whiteSpace: 'nowrap' }}>
                                                    {e.totalOreCumulateTaskuri}
                                                </TableCell>
                                                <TableCell style={{ whiteSpace: 'nowrap' }}>
                                                    {!String(e.totalOreDiferentaCompletare).includes('-') &&
                                                        <span>{Math.abs(Number(e.totalOreDiferentaCompletare))}</span>
                                                    }
                                                </TableCell>
                                                <TableCell style={{ whiteSpace: 'nowrap' }}>
                                                    {String(e.totalOreDiferentaCompletare).includes('-') &&
                                                        <span>{Math.abs(Number(e.totalOreDiferentaCompletare))}</span>
                                                    }
                                                </TableCell>
                                                <TableCell style={{ whiteSpace: 'nowrap' }}>
                                                    {!String(e.pctDepasire).includes('-') &&
                                                        <span>{Math.abs(Number(e.pctDepasire))}</span>
                                                    }
                                                </TableCell>
                                                <TableCell style={{ whiteSpace: 'nowrap' }}>
                                                    {String(e.pctDepasire).includes('-') &&
                                                        <span>{Math.abs(Number(e.pctDepasire))}</span>
                                                    }
                                                </TableCell>
                                                <TableCell >
                                                    {String(e.pctDepasire).includes('-') &&
                                                        <span style={{ color: 'green' }}>{this.dictionary.financiarContabil.utilizatorulTerminaTaskurileInainteDeTermen}{e.pctDepasire}%.</span>}
                                                    {!String(e.pctDepasire).includes('-') &&
                                                        <span style={{ color: 'red' }}>{this.dictionary.financiarContabil.utilizatorulDepasesteTaskurile} {e.pctDepasire}%.</span>}
                                                </TableCell>

                                            </TableRow>
                                        )
                                    })}


                                </TableBody>
                            </Table>
                            <div className='chartDIv'>
                            {this.state.chartData2 &&

                                <HorizontalBar

                                    datasetKeyProvider={() => { return Math.random() }}
                                    // getElementAtEvent={(element)=>this.getLineData(element,i)}
                                    plugins={[ChartDataLabels]}

                                    data={{
                                        labels: this.state.chartData2.labels.map((r, idx) => { return (r) }),

                                        datasets: this.state.chartData2.chartData.map((r, idx) => {
                                            return (
                                                {
                                                    label: r.user,
                                                    backgroundColor: new Utils().culoriCharts(idx),
                                                    hoverBackgroundColor: new Utils().culoriCharts(idx),
                                                    data: r.chartData.map((r) => { return (Number(r.value.toFixed(2))) }),

                                                }
                                            )

                                        })




                                    }}

                                    options={{

                                        onClick: function (evt, elements) {

                                            let selectedIndex = null
                                            if (elements && elements.length) {
                                                var segment = elements[0];
                                                this.update();
                                                if (selectedIndex !== segment["_index"]) {
                                                    selectedIndex = segment["_index"];
                                                    segment._model.outerRadius += 20;
                                                }
                                                else {
                                                    selectedIndex = null;
                                                }
                                            }
                                        },
                                        layout: {
                                            padding: 60,
                                            height: 300
                                        },

                                        plugins: {

                                            datalabels: {
                                                color: 'black',
                                                formatter: (value, context) => {
                                                  //  console.log('value :', value);
                                                    //    console.log('context :', );
                                                    if (value > 0) {
                                                        return value
                                                    } else {
                                                        return ''
                                                    }


                                                },
                                                font: {
                                                    size: 13,
                                                    weight: 600
                                                },
                                                align: 'end',
                                                clamp: true


                                            },

                                        },
                                        legend: {
                                            display: 'bottom'
                                        }
                                    }}

                                />

                            }
                        </div>
          </div>
          </div>
           
         </div>
        );
       }
}